import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'STUDENT_PROFILE_GET',
  GET_SUCCESS: 'STUDENT_PROFILE_GET_SUCCESS',
  GET_FAILURE: 'STUDENT_PROFILE_GET_FAILURE',

  POST: 'STUDENT_PROFILE_POST',
  POST_SUCCESS: 'STUDENT_PROFILE_POST_SUCCESS',
  POST_FAILURE: 'STUDENT_PROFILE_POST_FAILURE',

  PATCH: 'STUDENT_PROFILE_PATCH',
  PATCH_SUCCESS: 'STUDENT_PROFILE_PATCH_SUCCESS',
  PATCH_FAILURE: 'STUDENT_PROFILE_PATCH_FAILURE',

  INVALIDATE_ITEM: 'STUDENT_PROFILE_INVALIDATE_ITEM',
};

export const get = actions.get(
  studentId => `${BASE_URL}/students/${studentId}/profile/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);

export const post = actions.post(
  (id, value, { studentId }) => `${BASE_URL}/students/${studentId}/profile/`,
  {
    PENDING: ACTIONS.POST,
    SUCCESS: ACTIONS.POST_SUCCESS,
    FAILURE: ACTIONS.POST_FAILURE,
  },
);

export const patch = actions.patch(
  studentId => `${BASE_URL}/students/${studentId}/profile/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);

export const invalidateItem = id => dispatch => {
  dispatch({
    type: ACTIONS.INVALIDATE_ITEM,
    payload: { id },
  });
};
